import React, { PropsWithChildren } from 'react';

import { ButtonComponentProps, getButtonProps } from '../util/buttonProps';

import './DefaultButton.css';

function DefaultButton(props: PropsWithChildren<ButtonComponentProps>) {
  const { label, href, disabled, onClick, type } = props;
  const baseProps = getButtonProps(props, 'Default');

  return href && !disabled ? (
    <a {...baseProps} href={href}>
      {props.children || label}
    </a>
  ) : (
    <button
      {...baseProps}
      onClick={onClick}
      onKeyDown={onClick}
      disabled={disabled}
      type={type}
    >
      {props.children || label}
    </button>
  );
}

DefaultButton.defaultProps = {
  id: '',
  className: '',
  label: '',
  href: '',
  disabled: false,
  type: 'button',
};

export default DefaultButton;
